module.exports = {"pages":{"list":{"tabs":{"list":"List","changelog":"Changelog"}}}}


//////////////////
// WEBPACK FOOTER
// ./src/app/i18n/en/addressbook.json
// module id = 2385
// module chunks = 1